module.exports = __webpack_public_path__ + "static/media/brand19.e0e90aab.png";